/* unplugin-vue-components disabled */import __unplugin_components_3 from '/var/repos/bic-vue/src/components/navbar/BaseNavbar.vue';
import __unplugin_components_2 from '/var/repos/bic-vue/src/components/modals/LoginModal.vue';
import __unplugin_components_1 from '/var/repos/bic-vue/src/components/modals/AddToCartModal.vue';
import __unplugin_components_0 from '/var/repos/bic-vue/src/components/navbar/BoxConfigurationDropdown.vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "flex w-full justify-end"
};
const _hoisted_2 = {
  class: "flex items-center mr-2 md:mr-6 md:divide-x md:divide-slate-600"
};
const _hoisted_3 = {
  class: "md:pr-5"
};
const _hoisted_4 = {
  key: 0,
  class: "hidden md:flex"
};
const _hoisted_5 = {
  class: "navbar__my-account h-full mr-2 md:mr-4 my-auto ml-auto"
};
const _hoisted_6 = {
  class: "flex",
  href: "/my-account"
};
const _hoisted_7 = {
  class: "avatar my-auto"
};
const _hoisted_8 = {
  class: "w-[42px] md:w-[48px] p-2 ml-2 md:ml-0 rounded-full bg-[#191e24]"
};
const _hoisted_9 = {
  class: "flex items-center font-light"
};
const _hoisted_10 = {
  class: "hidden lg:block h-6 mr-1.5 leading-6"
};
const _hoisted_11 = {
  class: "rounded-full flex items-center justify-center w-7 h-7 bg-white/15"
};
const _hoisted_12 = {
  key: 1,
  class: "hidden md:block"
};
const _hoisted_13 = {
  id: "my_modal_3",
  class: "modal"
};
const _hoisted_14 = {
  method: "dialog",
  class: "modal-box",
  "data-theme": "light"
};
const _hoisted_15 = {
  onclick: "my_modal_3.close()",
  class: "btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
};
const _hoisted_16 = {
  class: "flex items-center"
};
const _hoisted_17 = {
  class: "flex items-center font-light"
};
const _hoisted_18 = {
  class: "flex items-center h-6 mr-1 md:mr-1.5 text-xs md:text-sm leading-1"
};
const _hoisted_19 = {
  class: "rounded-full"
};
const _hoisted_20 = {
  key: 1,
  class: "rounded-full flex items-center justify-center w-5 h-5 md:w-7 md:h-7 ml-1.5 bg-white/15"
};
import { useConfiguratorStore } from '@/stores/configurator';
import { useCartStore } from '@/stores/cart';
import { useAuthStore } from '@/stores/auth';
import { useConfigurationStore } from '@/stores/configurationModule';
import { useAppStateStore } from '@/stores/appState';
import { useWindowSize } from '@vueuse/core';
import { normalizePrice, formatPrice } from '@/utils/common';
import SvgIcon from '../common/SvgIcon.vue';
export default {
  __name: 'ConfiguratorNavbar',
  setup(__props) {
    // import { BOX_TYPES } from '@/box/BoxTypes'
    const $eventBus = inject('bus');
    const {
      width: windowWidth
    } = useWindowSize();
    const appState = useAppStateStore();
    const {
      useBoxQueryParametersError
    } = storeToRefs(appState);
    const authStore = useAuthStore();
    const {
      isUser
    } = storeToRefs(authStore);
    const cartStore = useCartStore();
    const {
      // productPrice,
      // boxQuantityOptions,
      currentProductPrice
    } = storeToRefs(cartStore);
    const configuratorStore = useConfiguratorStore();
    const {
      isSaving,
      isAddingToCart,
      mobileBreakpoint
    } = storeToRefs(configuratorStore);
    const {
      closeDrawer
    } = configuratorStore;
    const configurationStore = useConfigurationStore();
    const {
      boxQuantity
      // boxType,
    } = storeToRefs(configurationStore);
    const totalPrice = computed(() => {
      if (!boxQuantity.value || !currentProductPrice.value) return 0.00;
      const total = boxQuantity.value * currentProductPrice.value;
      return normalizePrice(total); // Round to 2 decimal places
    });
    function saveConfig() {
      $eventBus.$emit('save-config');
    }
    function onClickAddToCart() {
      if (isUser.value) {
        $eventBus.$emit('add-to-cart');
      } else {
        onClickOpenLoginModal('login');
      }
    }
    function onClickOpenLoginModal(whichModal) {
      // selectedForm.value = whichModal
      $eventBus.$emit('open-login-modal', whichModal);
    }
    return (_ctx, _cache) => {
      const _component_BoxConfigurationDropdown = __unplugin_components_0;
      const _component_AddToCartModal = __unplugin_components_1;
      const _component_LoginModal = __unplugin_components_2;
      const _component_BaseNavbar = __unplugin_components_3;
      return _openBlock(), _createBlock(_component_BaseNavbar, {
        class: "h-navBarHeight",
        onClick: _unref(closeDrawer)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_unref(isUser) ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("a", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(SvgIcon, {
          svgSymbolId: "account-circle",
          class: "w-full h-full"
        })])])])]), _unref(windowWidth) >= _unref(mobileBreakpoint) ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass([{
            'btn-disabled': _unref(isSaving)
          }, "btn sm:max-lg:btn-circle lg:rounded-full capitalize opacity-100"]),
          onClick: saveConfig
        }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('configurator.saveDesign')), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", null, [!_unref(isSaving) ? (_openBlock(), _createBlock(SvgIcon, {
          key: 0,
          svgSymbolId: "save-design",
          class: "lg:hidden w-5 h-5"
        })) : _createCommentVNode("", true), !_unref(isSaving) ? (_openBlock(), _createBlock(SvgIcon, {
          key: 1,
          svgSymbolId: "check-all",
          class: "hidden lg:block w-5 h-5"
        })) : _createCommentVNode("", true), _unref(isSaving) ? (_openBlock(), _createBlock(SvgIcon, {
          key: 2,
          svgSymbolId: "progress-activity",
          class: _normalizeClass(["w-5 h-5", {
            'animate-spin': _unref(isSaving)
          }])
        }, null, 8, ["class"])) : _createCommentVNode("", true)])])])], 2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !_unref(isUser) ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createTextVNode(" Save your project for later - "), _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = $event => onClickOpenLoginModal('register')),
          class: "underline pointer"
        }, "Sign up"), _createTextVNode(" or "), _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = $event => onClickOpenLoginModal('login')),
          class: "underline pointer"
        }, "Log in")])) : _createCommentVNode("", true), _createElementVNode("dialog", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("button", _hoisted_15, [_createVNode(SvgIcon, {
          svgSymbolId: "add-to-cart",
          class: "w-7 h-7"
        })])])])]), !_unref(useBoxQueryParametersError) ? (_openBlock(), _createBlock(_component_BoxConfigurationDropdown, {
          key: 0,
          class: "hidden md:block"
        })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [!_unref(useBoxQueryParametersError) ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass(["btn rounded-full capitalize", {
            'btn-disabled': _unref(isAddingToCart)
          }]),
          onClick: onClickAddToCart
        }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('configurator.addToCart', {
          price: _unref(formatPrice)(_unref(totalPrice))
        })), 1), _createElementVNode("div", _hoisted_19, [_createElementVNode("span", null, [!_unref(isAddingToCart) ? (_openBlock(), _createBlock(SvgIcon, {
          key: 0,
          svgSymbolId: "add-to-cart",
          class: "w-5 h-5 md:w-7 md:h-7"
        })) : _createCommentVNode("", true), _unref(isAddingToCart) ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(SvgIcon, {
          svgSymbolId: "progress-activity",
          class: _normalizeClass(["w-3 h-3 md:w-5 md:h-5", {
            'animate-spin': _unref(isAddingToCart)
          }])
        }, null, 8, ["class"])])) : _createCommentVNode("", true)])])])], 2)) : _createCommentVNode("", true)])]), _createVNode(_component_AddToCartModal), _createVNode(_component_LoginModal)]),
        _: 1
      }, 8, ["onClick"]);
    };
  }
};